import { getBootstrapData } from '@experience/core-hostapp-share-lib';
import { useAnalytics, type TConvertEventsMap } from '@experience/frontend-analytics';
import { useRuntimeConfig } from 'virtual:runtime-config';
import { computed } from 'vue';
import type { EventsMap } from '@/shared/api/sogu';

const runtimeConfig = useRuntimeConfig()['help-center-mfe'] || {};
const bootstrappedUserId = computed(() => getBootstrapData()?.userId);

const { trackEvent } = useAnalytics<TConvertEventsMap<EventsMap>>({
  soguURL: runtimeConfig.VITE_RUNTIME_SOGU_SERVICE_URL ?? '',
  appName: 'help-center-mfe',
  appVersion: __APP_VERSION__,
  userId: computed(() => bootstrappedUserId.value?.toString() || null),
});

export { trackEvent };
